<div class="outer-container" [ngClass]="{ 'disabled': disabled, 'large-button': largeButton }">
  <button [type]="type" mat-button [disableRipple]="disabled" (click)="onClick()" libStopPropagation
    [ngClass]="{'large-button': largeButton, 'disabled': disabled, 'primary-kind': (kind === ActionButtonKind.PRIMARY), 'secondary-kind': (kind === ActionButtonKind.SECONDARY), 'alert-kind': (kind === ActionButtonKind.ALERT), 'alert-tone-positive': (alertTone === ActionButtonAlertTone.Positive), 'alert-tone-neutral': (alertTone === ActionButtonAlertTone.Neutral), 'stroked-kind': (kind === ActionButtonKind.STROKED), 'filter-kind': (kind === ActionButtonKind.FILTER) }"
    [ngStyle]="{'min-width': minWidthInPixels + 'px'}">
    <div class="inner-container" [ngClass]="{ 'icon-after-text': iconAfterText, 'large-button': largeButton }">
      @if (image && !fontImage) {
        <div class="vertical-center">
          <img [src]="image" />
        </div>
      }
      @if (!image && fontImage) {
        <div class="vertical-center">
          <i [class]="fontImage"></i>
          @if (fontImageExtra) {
            <i [class]="fontImageExtra"></i>
          }
        </div>
      }
      @if (label && ((image && !fontImage) || (!image && fontImage))) {
        <div class="spacer"></div>
      }
      <div class="label vertical-center">{{ label }}</div>
    </div>
  </button>
  @if (badge) {
    <span class="badge">
      {{ badge }}
    </span>
  }
</div>
